<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Goals</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Goals</li>
                </ul>
              </div>
            
            </div>
          </div>
          <!-- /Page Header -->
                              <div class="row">
                                <div class="col-md-12">
                                   <div class="card">
                              <div class="card-body">
                                <div class="row">
                                    <button class="btn btn-white text-primary ml-3">
                                      <i class="la la-save"></i> Save
                                    </button>
                                </div>
                                <hr>
                                <form>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Activity Type <span class="text-danger">*</span></label>
                                                <select placeholder="Select Activity Type" class="form-control">
                                                    <option disabled value="">Select Activity Type</option>
                                                    <option>
                                                        Adele Vance
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Employee <span class="text-danger">*</span></label>
                                                <select placeholder="Select Employee" class="form-control">
                                                    <option disabled value="">Select Employee</option>
                                                    <option>
                                                        Adele Vance
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <label
                                                >Description <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control">
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>
                                                    Date <span class="text-danger">*</span>
                                                </label>
                                                <div class="cal-icon">
                                                <datepicker
                                                    calendar-class
                                                    input-class
                                                    bootstrap-styling
                                                    class="form-control datetimepicker"
                                                    type="text"
                                                />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>
                                                    Source <span class="text-danger">*</span>
                                                </label>
                                                <select placeholder="Select Employee" class="form-control">
                                                <option disabled value="">Select Source</option>
                                                <option>
                                                    *
                                                </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>
                                                    Status <span class="text-danger">*</span>
                                                </label>
                                                <select placeholder="Select Employee" class="form-control">
                                                <option disabled value="">Select Status</option>
                                                <option>
                                                    Not Started
                                                </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                              </div>
                              </div>
                                </div>
                               
                              </div>
                              
                                
                           
          <!-- /Page Content -->
        </div>
        <v-dialog v-model="dialogDelete" max-width="725px"
          >
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete </h3>
                  <p>Are you sure want to delete this?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from '@/services/authenticationService';
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
      return {
        dialogDelete: false,
        employeeId: this.$route.params.id,
        company: authenticationService.currentOfficeValue,
        submitted: false,
        loading: false,
        error: ""
    }
   },
  mounted() {
        
        if ($('.datatable').length > 0) {
            $('.datatable').DataTable({
            "bFilter": false,
            });
        }
  },

  methods: {
   
  },
  name: "addGoalActivity"
};
</script>
<style scoped>

.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/addGoalActivity.vue